export default "__VITE_ASSET__lZcm$8NB__"